<div class="prescriptions-container">
  <div class="prescriptions-header">
    <div class="container" [class.d-none]="showAdvancedSearch">
      <!-- Primary Logo -->
      <div *ngIf="logoUrl" class="page-header__logo">
        <ng-container *ngIf="logoRedirectUrl; else noPrimaryRedirect">
          <a [routerLink]="logoRedirectUrl" [title]="clientName" [appDisableOpenNewTab]="true">
            <img class="page-header__logo-image" [src]="logoUrl" [alt]="logoAlterativeText" />
          </a>
        </ng-container>

        <ng-template #noPrimaryRedirect>
          <img class="page-header__logo-image" [src]="logoUrl" [alt]="logoAlterativeText" />
        </ng-template>
      </div>

      <!-- Secondary Logo -->
      <div *ngIf="secondaryLogoUrl" class="page-header__logo">
        <ng-container *ngIf="secondaryLogoRedirectUrl; else noSecondaryRedirect">
          <a [routerLink]="secondaryLogoRedirectUrl" [title]="secondaryLogoAlternativeText" [appDisableOpenNewTab]="true">
            <img class="page-header__logo-image" [src]="secondaryLogoUrl" [alt]="secondaryLogoAlternativeText" />
          </a>
        </ng-container>

        <ng-template #noSecondaryRedirect>
          <img class="page-header__logo-image" [src]="secondaryLogoUrl" [alt]="secondaryLogoAlternativeText" />
        </ng-template>
      </div>

      <!-- Full Header Section -->
      <ng-container *ngIf="showFullHeader">
        <!-- Find Prescriptions -->
        <div class="page-header__search">
          <div class="form-group">
            <div class="input-group autocomplete-container">
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [placeholder]="findPrescriptionsPlaceholder"
                [attr.aria-label]="findPrescriptionsPlaceholder"
                (focus)="openAdvancedSearch()"
              />
              <span class="input-group__btn">
                <button class="btn btn--primary Spa_Style_PrimaryButton" aria-label="Search" (click)="openAdvancedSearch()">
                  <i class="fas fa-search"></i>
                </button>
              </span>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <nav class="primary-nav">
          <ul class="primary-nav__list">
            <li *ngIf="showPrescriptionsTab" class="primary-nav__item">
              <a class="primary-nav__link" [routerLink]="PagePath.ACCOUNT_PRESCRIPTIONS" [appDisableOpenNewTab]="true">
                {{ prescriptionsTabText }}
                <span class="badge badge--warn" *ngIf="selectedDrugs.length">{{ selectedDrugs.length }}</span>
              </a>
            </li>
            <li *ngIf="showPharmaciesTab" class="primary-nav__item">
              <a
                class="primary-nav__link"
                [routerLink]="!isMailOrderCostsSelected ? PagePath.PHARMACIES : null"
                [appDisableOpenNewTab]="true"
                [class.disabled]="isMailOrderCostsSelected"
                >{{ pharmaciesTabText }}</a
              >
            </li>
            <li *ngIf="showCoverageTab" class="primary-nav__item">
              <a
                class="primary-nav__link"
                [routerLink]="hasSelectedDrugs ? PagePath.ACCOUNT_COVERAGE : null"
                [appDisableOpenNewTab]="true"
                [class.disabled]="!hasSelectedDrugs"
                >{{ coverageTabText }}</a
              >
            </li>
            <li *ngIf="showAnnualCostTab" class="primary-nav__item">
              <a
                class="primary-nav__link"
                [routerLink]="hasSelectedDrugs ? PagePath.ANNUAL_COST_REPORT : null"
                [appDisableOpenNewTab]="true"
                [class.disabled]="!hasSelectedDrugs"
                >{{ annualCostTabText }}</a
              >
            </li>
          </ul>
        </nav>
      </ng-container>
    </div>

    <div *ngIf="showAdvancedSearch" class="form-group">
      <app-drug-search
        [showCloseButton]="true"
        [autoFocus]="true"
        [closeButtonText]="closeText"
        (search)="onSearch($event)"
        (drugSelected)="selectDrug($event)"
        (close)="closeAdvancedSearch()"
      >
      </app-drug-search>
    </div>
  </div>
</div>
